import DebugRow from 'features/debug/components/DebugRow'
import { useDealByBundleType } from '@order/hooks/useDeal'
import { usePackages, usePackageVariant } from '@order/hooks/usePackages'
import { useOrderState } from '@order/hooks/useOrderState'
import { useResolvedDealsContext } from 'hooks/useSession'
import useStepCtx from '@order/steps/useStepCtx'
import { ScrollView } from 'react-native'

export default function ConfigDebugView() {
  const ctx = useStepCtx()
  const dealCtx = useResolvedDealsContext()
  const deals = useDealByBundleType()
  const { activePackage, initialPackage } = usePackages()
  const currentPackage = activePackage ?? initialPackage
  const variant = usePackageVariant(currentPackage)
  const activeItemId = useOrderState((s) => s.order.activeItemId)
  const items = useOrderState((s) => s.order.items)
  const stock = useOrderState((s) => s.order.stock)

  return (
    <ScrollView className="flex-1">
      <DebugRow label="Flow" value={ctx.flowName} />
      <DebugRow
        label="Items Slice"
        value={{ activeItemId, items, stock }}
        initialOpen={false}
      />
      <DebugRow label="Deal Context" value={dealCtx} />
      <DebugRow label="Resolved Deal" value={deals} />
      <DebugRow label="Package" value={currentPackage} initialOpen={false} />
      <DebugRow label="Package Variant" value={variant} initialOpen={false} />
      <DebugRow label="States" value={ctx.state.states} />
      <DebugRow label="Values" value={ctx.values} />
      <DebugRow label="Refraction" value={ctx.refraction} />
    </ScrollView>
  )
}
